module.exports = __webpack_public_path__ + "img/banner-front-page-1920.95ca5b20.webp";